import React, { ReactNode, useState } from 'react';
import { COLORS } from '../../../../../v3/global';
import './meeting-card-buttons.styles.scss';
// eslint-disable-next-line import/order
import { mergeClassNames } from 'apps/agora/src/utils/helpers';

type Props = {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
};

const MeetingListItemButton = ({ children, className, disabled = false }: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor:
          !disabled && isHovered ? COLORS.SURFACE_BACKGROUND : COLORS.TRANSPARENT,
      }}
      className={mergeClassNames(
        'meeting-list-item-button-container',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className
      )}
    >
      {children}
    </div>
  );
};

export default MeetingListItemButton;
